import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/LG360W.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="LG 360W" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/LG360W.js